import React from 'react';
import './Slider.scss'
import news from '../../assets/images/asianews.jpg'
import CRE from '../../assets/images/CRE.png'
import two from '../../assets/images/2.jpg'
import PDA from '../../assets/images/PDA.jpg'
import three from '../../assets/images/3.jpg'
import four from '../../assets/images/1.jpg'


//https://www.pexels.com/ for images
const sliderData = [
  {
    image: news,
    heading: "East Asian News Web",
    desc: "A Full Stack Application that scrapes popular online newspapers for chinese, japanese, and korean news. It uses my rapid api backend to create the frontend.",
    link: "",
    git: "https://east-asian-news-previewer.netlify.app/",
    Language: "Node.js, React.js, HTML, CSS",
    colors:"#0088FE"
  },
  {
    image: CRE,
    heading: "CRE calculator",
    desc: "A simple CRE (Commercial Real Estate) calculator library, where the user inputs data and gets property present value using Discounted Cash Flow methodology.",
    link: "",
    git: "https://github.com/winsor-tse/CRE_calculator",
    Language: "C++",
    colors: "#00C49F"
  },
  {
    image: three,
    heading: "Modding Minecraft",
    desc: "Using the Java language, I modified the minecraft game to have custom items, mobs, etc. gets property present value using Discounted Cash Flow methodology.",
    link: "",
    git: "https://github.com/winsor-tse/MinecraftModdingFiles",
    Language: "Java",
    colors: "#BAD301"
  },
  {
    image: four,
    heading: "BTC/ETH price tracker",
    desc: "Using HTML, PHP, CSS and Javascript. The Website tracks information from the cyrpto compare api and the messari api. The Website uses HTML, Vanilla Javascript and CSS.",
    link: "",
    git: "https://github.com/winsor-tse/ETH-vs-BTC-crypto-tracker",
    Language: "PHP, HTML, CSS, Javascript",
    colors: "#CD0496"
  },
  {
    image: two,
    heading: "Ninja Game (Gdevelop)",
    desc: "Using the Gdevelop platform, this game is fully accessible using the source link below. You will playing as a ninja defeating enemies using shurikens and collecting scrolls",
    link: "",
    git: "https://github.com/winsor-tse/GDevelop-Platformer",
    Language: "Gdevelop",
    colors: "#FF957F"
  },
  {
    image: PDA,
    heading: "Push Down Automata",
    desc: "This project implementats a push-down automata which recognizes the language L={ a^nb^n| n ≥ 0}. It can also look-ahead one step, this project is build for Theory of Computation.",
    link: "",
    git: "https://github.com/winsor-tse/Deterministic-Push-Down-Automata",
    Language: "Java",
    colors: "#FF7FF0 "
  },
];


//add images as a list
//https://github.com/zinotrust/react-image-slider/blob/master/src/components/slider/Slider.js

const delay = 9000;

function Slideshow2() {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }
  
  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === sliderData.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);

  return (
    <div className="slideshow2">
      <div
        className="slideshowSlider"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {sliderData.map((slide, index) => (
          <div
            className="slide"
            key={index}
            style = {{background:slide.colors}} 
          >
            <img src={slide.image} className="s2"/>
            <h3 className="c">{slide.heading}</h3>
            <p className="d"> 
            
            {slide.desc}
            
            <br/>
            Language Used:
            <br/>
            {slide.Language}
            <br/>
            <a href={slide.git} target="_blank" rel="noreferrer">
          <button className="flat-button">Git Hub or Deployment</button>
          </a>
          </p>
          </div>
        ))}
      </div>

      <div className="slideshowDots">
        {sliderData.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot${index === idx ? " active" : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          >

          </div>
        ))}
      </div>
    </div>
  );
}

export default Slideshow2
